<div class="navbar-top" [ngClass]="fuseConfig.layout.navbar.secondaryBackground">

    <div class="logo">
        <img class="logo-icon" src="assets/images/logos/fuse.svg">
        <span class="logo-text secondary-text">Tangerine Marketplace</span>
    </div>

    <div class="buttons">

        <button mat-icon-button (click)="toggleSidebarFolded()" class="toggle-sidebar-folded fx-hide-lt-lg">
            <mat-icon class="secondary-text">menu</mat-icon>
        </button>

        <button mat-icon-button (click)="toggleSidebarOpened()" class="toggle-sidebar-opened fx-hide-gt-md">
            <mat-icon class="secondary-text">arrow_back</mat-icon>
        </button>

    </div>

</div>


<div class="navbar-scroll-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground"
     fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true}">

    <div [ngClass]="fuseConfig.layout.navbar.secondaryBackground" class="user fx-column">

        <div class="h3 username">Charlie Adams</div>
        <div class="h5 email hint-text mt-8">adams.charlie&#64;mail.com</div>
        <div class="avatar-container" [ngClass]="fuseConfig.layout.navbar.primaryBackground">
            <img class="avatar" src="assets/images/avatars/Velazquez.jpg">
        </div>

    </div>

    <div class="navbar-content">
        <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
    </div>

</div>
